import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import "rxjs/add/observable/fromPromise";
import { Observable } from "rxjs/Observable";

@Injectable()
export class GamificationData {

  constructor(
    private afDb: AngularFireDatabase,
  ) { }

  public saveGamification(
    client: string,
    gamification: any,
  ) {
    const check =  new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${client}/Gamification/`)
        .update(gamification)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });

    return Observable.fromPromise(check);
  }

  public getGamificationByClient(clientId: string) {
    return this.afDb.object(`Clients/${clientId}/Gamification`).valueChanges();
  }

}



// WEBPACK FOOTER //
// ./src/providers/gamification.ts